import Choices from 'choices.js';
import flatpickr from "flatpickr";
import Inputmask from "inputmask";
import handleRecaptcha from "../handle-recaptcha/handle-recaptcha";
import membershipObject from "../membership/membership";
import renderFields from "../forms/forms-renderfields";

const formEvents = function () {
  //date picker
  const dateSelector = document.querySelectorAll('.js-flatpickr'),
    simpleDateSelector = document.querySelectorAll('.datepicker'),
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const datePickerWithMaskInput = () => {
    Array.prototype.forEach.call(dateSelector, (el) => {

      let maskedInput = el.querySelector('.js-flatpickr--masked'),
        flatPickrInput = el.querySelector('.js-flatpickr--picker'),
        isMembershipForm = el.classList.contains('is-membership-form'),
        pickerToggle = el.querySelector('.form-date-picker__toggle'),
        isClickOnPickerToggle = false;

      const showFlatPickrInput = () => {
        flatPickrInput.classList.remove('hide');
        maskedInput.classList.remove('show');
      }

      const formatMaskedInput = (date) => {
        let formattedDate = date.split('/').join(' '),
          mm = formattedDate.slice(3, 5),
          index = parseInt(mm) - 1,
          formattedMonth = months[index];

        return formattedDate.slice(0, 2) + ' ' + formattedMonth + ' ' + formattedDate.slice(6, 10);
      }

      const formatFlatInput = (date) => {
        let mm = date.length == 10 ? date.slice(2, 5) : date.slice(3, 6),
          index = months.indexOf(mm),
          monthInt = parseInt(index) + 1,
          formattedMonth = monthInt < 10 ? '0' + monthInt : monthInt;

        if (date.length == 10)
          return '0' + date.slice(0, 1) + '/' + formattedMonth + '/' + date.slice(6, 10);
        else
          return date.slice(0, 2) + '/' + formattedMonth + '/' + date.slice(7, 11);
      }

      const isValidMaskedInput = (value) => {
        if (value.indexOf('d') > -1)
          return false;

        if (value.indexOf('m') > -1)
          return false;

        if (value.indexOf('y') > -1)
          return false;

        if (value == '')
          return false;

        return true;
      };

      //init mask on the secondary input
      Inputmask({ alias: "datetime", inputFormat: "dd/mm/yyyy" }).mask(maskedInput);

      //if user types all the required digits, the input is formatted and the primary input is shown
      maskedInput.addEventListener('blur', function () {
        let currentValue = this.value;

        if (!isValidMaskedInput(currentValue)) {
          showFlatPickrInput();
          return false;
        }

        let date = formatMaskedInput(currentValue);
        flatPickrInput.value = date;
        flatPickrInput.classList.add('selected');

        if (isMembershipForm)
          el.classList.remove('empty');

        showFlatPickrInput();
      });

      maskedInput.addEventListener('focus', function () {
        if (isMembershipForm)
          el.classList.remove('empty');
      });

      flatpickr(el, {
        dateFormat: "j M Y",
        disableMobile: true,
        wrap: true,
        onReady: function (selectedDates, dateStr, instance) {

          pickerToggle.addEventListener('click', function () {
            isClickOnPickerToggle = true;
          });

          flatPickrInput.addEventListener('focus', function (event) {
            const eventKeydown = new Event('ondblclick');

            instance.close();

            this.classList.add('hide')
            maskedInput.classList.add('show');
            maskedInput.dispatchEvent(eventKeydown);
          });
        },
        onChange: function (selectedDates, dateStr, instance) {
          flatPickrInput.classList.add('selected');
          maskedInput.value = formatFlatInput(dateStr);
          if (isClickOnPickerToggle) {
            showFlatPickrInput();
            isClickOnPickerToggle = false;
          }
          maskedInput.classList.add('show');
        },
        onOpen: function (selectedDates, dateStr, instance) {
          el.parentElement.classList.add('opened')
        },
        onClose: function (selectedDates, dateStr, instance) {
          el.parentElement.classList.remove('opened');
        }
      });

    });
  }

  datePickerWithMaskInput();

  const simpleDatePicker = () => {
    Array.prototype.forEach.call(simpleDateSelector, (el) => {
      let flatPickrInput = el;
      flatpickr(el, {
        dateFormat: "j M Y",
        disableMobile: true,

        onChange: function (selectedDates, dateStr, instance) {
          flatPickrInput.classList.add('selected');
        },
        onOpen: function (selectedDates, dateStr, instance) {
          el.parentElement.classList.add('opened')
        },
        onClose: function (selectedDates, dateStr, instance) {
          el.parentElement.classList.remove('opened');
          $(el).valid();
        }
      })
    });
  }
  simpleDatePicker();

  const formSelect = document.getElementsByClassName('form-select-input');
  const formSelectWFFM = document.querySelectorAll('[data-wffm], [data-sc-fxb]');
  let choicesApplied = false;
  var choices;

  if (formSelect.length || formSelectWFFM.length) {

    const customSelectStyle = function () {
      if (window.innerWidth >= 768) {
        if (!choicesApplied) {

          if (document.querySelector('.form-select-input')) {
            const choices = new Choices('.form-select-input', {
              searchEnabled: false,
              shouldSort: false,
              itemSelectText: ''
            });
          }

          if ($('select.form-control:not([size])').length) {
            const choicesWFFM = new Choices('select.form-control:not([size])', {
              searchEnabled: false,
              shouldSort: false,
              itemSelectText: ''
            });
          }

          const choicesSelectBoxes = document.querySelectorAll('.form-select--float .choices, [data-wffm] .choices, [data-sc-fxb] .choices');
          Array.prototype.forEach.call(choicesSelectBoxes, (el) => {
            el.parentElement.classList.add('choices-form-select');
            const selectEl = el.querySelector('.choices__input');

            const applySelected = () => {
              if (selectEl.value === undefined || selectEl.value === null || selectEl.value === '') {
                el.classList.remove('selected');
                el.parentElement.classList.remove('selected');
              } else {
                el.classList.add('selected');
                el.parentElement.classList.add('selected');
              }
            }

            applySelected();
            $(selectEl).on('focusout change', function () {
              applySelected();
            })
          })
          choicesApplied = true;
        }
      } else {
        const selectBoxes = document.querySelectorAll('.form-select--float');
        Array.prototype.forEach.call(selectBoxes, (el) => {
          el.parentElement.classList.add('choices-form-select');
          const selectEl = el.querySelector('.form-select-input');
          selectEl.addEventListener('change', () => {
            if (selectEl.value === null || selectEl.value === '') {
              el.classList.remove('selected');
            } else {
              el.classList.add('selected');
            }
          })
        });

        const choicesSelectBoxes = document
          .querySelectorAll('[data-wffm] .form-group.choices-form-select, [data-sc-fxb] .form-group.choices-form-select');
        Array.prototype.forEach.call(choicesSelectBoxes, (el) => {
          const selectEl = el.querySelector('select.form-control');
          const applySelected = () => {
            if (selectEl.value === null || selectEl.value === '') {
              el.classList.remove('selected');
            } else {
              el.classList.add('selected');
            }
          }
          applySelected();
          $(selectEl).on('focusout change', function () {
            applySelected();
          })
        });
      }
    }
    customSelectStyle();
    $(window).smartresize(() => {
      customSelectStyle();
    })
  }

  // Floating Label select
  const selectFloatingLabelElements = document.querySelectorAll('.js-form-select.form-select-floating-label');
  if (selectFloatingLabelElements.length) {
    Array.prototype.forEach.call(selectFloatingLabelElements, (el) => {
      const selectEl = el.querySelector('.form-select-input');
      const childOptions = selectEl.querySelector('option');
      selectEl.addEventListener('focus', () => {
        if (selectEl.value === null || selectEl.value === '') {
          el.classList.add('empty');
        } else {
          el.classList.remove('empty');
        }
      });
      selectEl.addEventListener('keypress', () => {
        if (selectEl.value === null || selectEl.value === '') {
          el.classList.add('empty');
        } else {
          el.classList.remove('empty');
        }
      });

    });
  }


  // Floating Label inputs
  const textfieldFloatingLabelElements = document.querySelectorAll('.js-form-textfield.form-textfield-floating-label');
  if (textfieldFloatingLabelElements.length) {
    Array.prototype.forEach.call(textfieldFloatingLabelElements, (el) => {
      const inputEl = el.querySelector('.form-textfield-input');
      if (inputEl.value === null || inputEl.value === '') {
        el.classList.add('empty');
      }
      inputEl.addEventListener('change', () => {
        if (inputEl.value === null || inputEl.value === '') {
          el.classList.add('empty');
        }
      });

    });
  }

  // Floating Label inputs - WFFM
  const textfieldFloatingLabelElementsWFFM = document.querySelectorAll('form[data-wffm] input.form-control, form[data-wffm] textarea.form-control, form[data-sc-fxb] input.form-control, form[data-sc-fxb] textarea.form-control');
  if (textfieldFloatingLabelElementsWFFM.length) {
    Array.prototype.forEach.call(textfieldFloatingLabelElementsWFFM, (el) => {
      const inputEl = el;
      let parentEl = inputEl.parentElement;

      if (el.classList.contains('password')) {
        parentEl = inputEl.previousElementSibling;
      }
      if (inputEl.value === null || inputEl.value === '') {
        parentEl.classList.add('empty');
      }
      inputEl.addEventListener('focus', () => {
        parentEl.classList.remove('empty');
      });
      inputEl.addEventListener('keypress', () => {
        parentEl.classList.remove('empty');
      });
      inputEl.addEventListener('blur', () => {
        if (inputEl.value === null || inputEl.value === '') {
          parentEl.classList.add('empty');
        }
      });
    });
  }

  const submitBtnElementsWFFM = document.querySelectorAll('form[data-wffm] input.btn, form[data-sc-fxb] input.btn');
  if (submitBtnElementsWFFM.length) {
    Array.prototype.forEach.call(submitBtnElementsWFFM, (el) => {
      el.addEventListener('mousedown', (event) => {
        if (textfieldFloatingLabelElementsWFFM.length) {
          Array.prototype.forEach.call(textfieldFloatingLabelElementsWFFM, (el) => {
            let parentEl = el.parentElement;
            if ((el.value === null || el.value === '') && !$(parentEl).hasClass('empty')) {
              parentEl.classList.add('empty');
            }
          })
        }
        event.preventDefault();
      });
    })
  }

  //upload file type WFFM

  const fileUploadWFFM = document.querySelectorAll('form[data-wffm] input[type=file], form[data-sc-fxb] input[type=file]');
  if (fileUploadWFFM.length) {
    Array.prototype.forEach.call(fileUploadWFFM, (el) => {
      const inputEl = el;
      const parentEl = inputEl.parentElement;
      parentEl.classList.add('form-file-upload');
    });
  }

  //text area WFFM

  const textareaWFFM = document.querySelectorAll('form[data-wffm] textarea, form[data-sc-fxb] textarea');
  if (textareaWFFM.length) {
    Array.prototype.forEach.call(textareaWFFM, (el) => {
      const inputEl = el;
      const parentEl = inputEl.parentElement;
      parentEl.classList.add('form-textarea');
    });
  }

  //recaptcha
  const recaptchaWFFM = document.querySelectorAll('.g-recaptcha');
  if (recaptchaWFFM.length) {
    Array.prototype.forEach.call(recaptchaWFFM, (el) => {
      const inputEl = el;
      const parentEl = inputEl.parentElement;
      parentEl.classList.add('form-recaptcha');
    });
  }
  //password type WFFM

  const passwordWFFM = document.querySelectorAll('form[data-wffm] .password, form[data-sc-fxb] .password');
  if (passwordWFFM.length) {
    Array.prototype.forEach.call(passwordWFFM, (el) => {
      const inputEl = el;
      const parentEl = inputEl.parentElement;
      parentEl.classList.add('form-password');
    });
  }

  //list box multiple showing WFFM

  const listBoxWFFM = $('form[data-wffm] select[size], form[data-sc-fxb] select[size]');
  if (listBoxWFFM.length) {
    listBoxWFFM.each(function (i, el) {
      const inputEl = el;
      const parentEl = inputEl.parentElement;
      parentEl.classList.add('form-list-box');
    })
  }

  //date WFFM

  const dateWFFM = document.querySelectorAll('form[data-wffm] .wfmDatebox, form[data-sc-fxb] .wfmDatebox');
  if (dateWFFM.length) {
    Array.prototype.forEach.call(dateWFFM, (el) => {
      const inputEl = el;
      const parentEl = inputEl.parentElement;
      parentEl.classList.add('form-date');
    });
  }

  const radioLabel = $('.radio label');
  const checkboxLabel = $('.checkbox label');

  if (radioLabel.length) {
    $('.radio label').each((i, v) => {
      $(v).append('<span></span>');
    });
  }

  if (checkboxLabel.length) {
    $('.checkbox label').each((i, v) => {
      $(v).append('<span></span>');
    });
  }

  function mapQueryParamsToFormFieldValues() {
    var params = getQueryStringAsObject();
    if (params) {
      Object.keys(params)
        .filter(function (key) {
          return /^field-/.test(key);
        }).forEach(e => {
          var fieldName = e.replace("field-", "");
          var $field = $("[data-sc-field-name=" + fieldName + "]");
          if ($field.length) {
            $field.val(params[e]).parent(".form-group").removeClass("empty");
            $field.valid();
          }
        });
    }
  }
  mapQueryParamsToFormFieldValues();

  $('.rslqld-digital-membership-form .page-button').each(function () {
    $(this).parent().addClass('form-page-button');
    $(this).click(function (e) {
      var isValid = true;
      var form = document.getElementsByClassName("rslqld-digital-membership-form");
      if (form.length > 0) {
        if (!$(this).hasClass("btn--reverse")) {
          isValid = form[0].checkValidity() && ValidateDischargeAndEnlistmentDate(e);
        } else {
          if ($('input[type="email"]').length > 0) {
            $('input[type="email"]').each(function () {
              var regexattribute = $(this).attr('data-val-regex-pattern');
              if (typeof regexattribute !== 'undefined' && regexattribute !== false) {
                var reg = new RegExp(regexattribute);
                if (!reg.test($(this).val())) {
                  $(this).val('');
                }
              }
            });
          }
        }
      }
      var thisElem = this;
      var firstelem = $(thisElem).closest("form").find(':input, select, textarea').filter(':visible:first');
      if (firstelem.length > 0) {
        $('html,body').animate({ scrollTop: firstelem.offset().top + 200 }, 200, function () {
          firstelem.focus();
        })
      }
      if (isValid) ShowFormLoadingSpinner();
    })
  });

  if ($('.submit-membership-application-btn').length > 0)
    $('.submit-membership-application-btn').parent().addClass('form-page-button');

  $('#branchId').on('change', function () {
    if ($('input[data-sc-field-name="subbranch"]').length > 0) {
      $('input[data-sc-field-name="subbranch"]').val($('#subbranch').val());
      $('input[data-sc-field-name="branchId"]').val($('#branchId').val());
      if ($.trim($('#branchId').val()) !== '') {
        $('.rsqld-membershipform-subbranch-error').addClass('hidden');
      }
    }
  });

  $('#subbranch').on('change', function () {
    if ($('input[data-sc-field-name="subbranch"]').length > 0
      && $('input[data-sc-field-name="subbranch"]').val() !== $('#subbranch').val()) {
      $('input[data-sc-field-name="subbranch"]').val('');
      $('input[data-sc-field-name="branchId"]').val('');
      $('#branchId').val('')
      $('.rsqld-membershipform-subbranch-error').removeClass('hidden');
      if ($.trim($('#subbranch').val()) === '') {
        $('#subbranch').parent().addClass('empty');
      }
    }
  });

  if ($('input[data-sc-field-name="subbranch"]').length > 0 && $.trim($('input[data-sc-field-name="subbranch"]').val()) !== '') {
    $('#subbranch').val($('input[data-sc-field-name="subbranch"]').val());
    $('#branchId').val($('input[data-sc-field-name="branchId"]').val())
  }

  if ($('#subbranch').length > 0) {
    if ($('#subbranch').val() !== '')
      $('#subbranch').parent().removeClass('empty');
    $('#subbranch').on('focus', () => {
      $('#subbranch').parent().removeClass('empty');
    }).on('blur', () => {
      if ($('#subbranch').value === null || $('#subbranch').value === '') {
        $('#subbranch').parent().addClass('empty');
      }
    }).smartkeyup(() => {
      $.when(membershipObject.subBranchFinder($('#subbranch').val()))
    });
  }

  $('.membership-subbranch-btn').click(function () {
    if ($.trim($('#branchId').val()) !== '') {
      $('.rsqld-membershipform-subbranch-error').addClass('hidden');
      return true;
    } else {
      $('.rsqld-membershipform-subbranch-error').removeClass('hidden');
      return false;
    }
  });

  if ($('#rslqld-membershipform-thankyou__image').length === 1) {
    var offset = $("#rslqld-membershipform-thankyou__image").offset();
    $('html, body').animate({
      scrollTop: offset.top - 300,
      scrollLeft: offset.left
    }, 100);
  }

  $('#Declaration-accurate-information-is-true, #Declaration-agree-to-constitution, #Declaration-agree-to-privacy')
    .change(function () {
      var declaration = $('input[data-sc-field-name="Declaration"]').length > 0
        ? $('input[data-sc-field-name="Declaration"]').val() : '';
      if (this.checked) {
        $('.rsqld-membershipform-declaration-error').addClass('hidden');
        declaration = `${declaration} ,${$(this).val()}`.replace(/^ | $/g, '').replace(/^,|,$/g, '');
      } else {
        $('.rsqld-membershipform-declaration-error').removeClass('hidden');
        declaration = declaration.replace(" ," + $(this).val(), '').replace($(this).val(), '')
          .replace(/^ | $/g, '').replace(/^,|,$/g, '');
      }
      if ($('input[data-sc-field-name="Declaration"]').length > 0) {
        $('input[data-sc-field-name="Declaration"]').val(declaration);
      }
    });

  $('.submit-membership-application-btn').click(function () {
    if ($('#Declaration-accurate-information-is-true').length > 0) {
      if ($('#Declaration-accurate-information-is-true').is(':checked') === false) {
        $('.rsqld-membershipform-declaration-error').removeClass('hidden');
        return false;
      }
    }
    if ($('#Declaration-agree-to-constitution').length > 0) {
      if ($('#Declaration-agree-to-constitution').is(':checked') === false) {
        $('.rsqld-membershipform-declaration-error').removeClass('hidden');
        return false;
      }
    }
    if ($('#Declaration-agree-to-privacy').length > 0) {
      if ($('#Declaration-agree-to-privacy').is(':checked') === false) {
        $('.rsqld-membershipform-declaration-error').removeClass('hidden');
        return false;
      }
    }
    $('.rsqld-membershipform-declaration-error').addClass('hidden');
    ShowFormLoadingSpinner();
    return true;
  });

  function ShowFormLoadingSpinner() {
    if ($('.form-loading-spinner').length > 0) {
      $('.form-loading-spinner').each(function (index) {
        if (index === 0) {
          $(this).show();
        } else {
          $(this).remove();
        }
      });
    }
  }

  $('.membershipform-postaladdress-checkbox').change(function () {
    if (this.checked) {
      $('.membershipform-postaladdress-textbox').val($('.membershipform-residentialaddress-textbox').val())
      if ($('.membershipform-postaladdress-textbox').length > 0)
        $('.membershipform-postaladdress-textbox').parent().removeClass('empty')
      $('.membershipform-postalsuburb-textbox').val($('.membershipform-residentialsuburb-textbox').val())
      if ($('.membershipform-postalsuburb-textbox').length > 0)
        $('.membershipform-postalsuburb-textbox').parent().removeClass('empty')
      $('.membershipform-postalpostcode-textbox').val($('.membershipform-residentialpostcode-textbox').val())
      if ($('.membershipform-postalpostcode-textbox').length > 0)
        $('.membershipform-postalpostcode-textbox').parent().removeClass('empty')

      if ($('.membershipform-postalstate-textbox').length > 0) {
        $('.membershipform-postalstate-textbox').parent().removeClass('empty')
        $('.membershipform-postalstate-textbox').parent().addClass('selected')
        if ($('.membershipform-postalstate-textbox option').length > 0) {
          if ($('.membershipform-postalstate-textbox').next('.choices__list.choices__list--single').length > 0 &&
            $('.membershipform-postalstate-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable').length > 0) {
            $('.membershipform-postalstate-textbox option')
              .val($('.membershipform-residentialstate-textbox').val())
              .text($('.membershipform-residentialstate-textbox').text())
            $('.membershipform-postalstate-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable')
              .attr('data-value', $('.membershipform-residentialstate-textbox').val())
              .text($('.membershipform-residentialstate-textbox').text())
          } else {
            if ($('.membershipform-residentialstate-textbox').length > 0 && $('.membershipform-residentialstate-textbox').val() !== '') {
              $('.membershipform-postalstate-textbox option[value=' + $('.membershipform-residentialstate-textbox').val() + ']')
                .attr('selected', 'selected');
            }
          }
        }
        $('.membershipform-postalstate-textbox').change()
      }
      if ($('.membershipform-postalcountry-textbox').length > 0) {
        $('.membershipform-postalcountry-textbox').parent().removeClass('empty')
        $('.membershipform-postalcountry-textbox').parent().addClass('selected')
        if ($('.membershipform-postalcountry-textbox option').length > 0) {
          if ($('.membershipform-postalcountry-textbox').next('.choices__list.choices__list--single').length > 0 &&
            $('.membershipform-postalcountry-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable').length > 0) {
            $('.membershipform-postalcountry-textbox option')
              .val($('.membershipform-residentialcountry-textbox').val())
              .text($('.membershipform-residentialcountry-textbox').text())
            $('.membershipform-postalcountry-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable')
              .attr('data-value', $('.membershipform-residentialcountry-textbox').val())
              .text($('.membershipform-residentialcountry-textbox').text())
          } else {
            if ($('.membershipform-residentialcountry-textbox').length > 0 && $('.membershipform-residentialcountry-textbox').val() !== '') {
              $('.membershipform-postalcountry-textbox option[value=' + $('.membershipform-residentialcountry-textbox').val() + ']')
                .attr('selected', 'selected');
            }
          }
        }
        $('.membershipform-postalcountry-textbox').change()
      }
    } else {
      $('.membershipform-postaladdress-textbox').val('')
      if ($('.membershipform-postaladdress-textbox').length > 0)
        $('.membershipform-postaladdress-textbox').parent().addClass('empty')
      $('.membershipform-postalsuburb-textbox').val('')
      if ($('.membershipform-postalsuburb-textbox').length > 0)
        $('.membershipform-postalsuburb-textbox').parent().addClass('empty')
      $('.membershipform-postalpostcode-textbox').val('')
      if ($('.membershipform-postalpostcode-textbox').length > 0)
        $('.membershipform-postalpostcode-textbox').parent().addClass('empty')

      if ($('.membershipform-postalstate-textbox').length > 0) {
        $('.membershipform-postalstate-textbox').parent().addClass('empty')
        $('.membershipform-postalstate-textbox').parent().removeClass('selected')
        if ($('.membershipform-postalstate-textbox option').length > 0) {
          if ($('.membershipform-postalstate-textbox').next('.choices__list.choices__list--single').length > 0 &&
            $('.membershipform-postalstate-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable').length > 0) {
            $('.membershipform-postalstate-textbox option')
              .val('').text('')
            $('.membershipform-postalstate-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable')
              .attr('data-value', '').text('')
          } else {
            if ($('.membershipform-residentialstate-textbox').length > 0 && $('.membershipform-residentialstate-textbox').val() !== '') {
              $('.membershipform-postalstate-textbox option[value=' + $('.membershipform-residentialstate-textbox').val() + ']')
                .removeAttr('selected');
            }
          }
        }
        $('.membershipform-postalstate-textbox').change()
      }

      if ($('.membershipform-postalcountry-textbox').length > 0) {
        $('.membershipform-postalcountry-textbox').parent().addClass('empty')
        $('.membershipform-postalcountry-textbox').parent().removeClass('selected')
        if ($('.membershipform-postalcountry-textbox option').length > 0) {
          if ($('.membershipform-postalcountry-textbox').next('.choices__list.choices__list--single').length > 0 &&
            $('.membershipform-postalcountry-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable').length > 0) {
            $('.membershipform-postalcountry-textbox option')
              .val('').text('')
            $('.membershipform-postalcountry-textbox').next('.choices__list.choices__list--single')
              .children('.choices__item.choices__item--selectable')
              .attr('data-value', '').text('')
          } else {
            if ($('.membershipform-residentialcountry-textbox').length > 0 && $('.membershipform-residentialcountry-textbox').val() !== '') {
              $('.membershipform-postalcountry-textbox option[value=' + $('.membershipform-residentialcountry-textbox').val() + ']')
                .removeAttr('selected');
            }
          }
        }
        $('.membershipform-postalcountry-textbox').change()
      }
    }
  });

  $('.rslqld-digital-membership-form.rslqld-membership-form-fields')
    .find("select.cssGender").each(function () {
      $(this).on('change', function () {
        $('.rslqld-digital-membership-form.rslqld-membership-form-fields')
          .find('.checkIfDisabled').each(function () {
            if ($(this).is(':disabled')) {
              $(this).val('');
              $(this).parent().addClass('empty')
            }
          });
      });
    });

  var digitalmembershipform_DichargeDate = $('.rslqld-digital-membership-form.rslqld-membership-form-fields .cssDischargeDate');
  var digitalmembershipform_EnlistmentDate = $('.rslqld-digital-membership-form.rslqld-membership-form-fields .cssEnlistmentDate');

  function ValidateDischargeAndEnlistmentDate(e) {
    if (digitalmembershipform_DichargeDate.length > 0 && digitalmembershipform_EnlistmentDate.length > 0 &&
      digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').length > 0
      && digitalmembershipform_EnlistmentDate.siblings('input.dob-input-mask-field-datepicker').length > 0) {
      var EnlistmentDateVal = digitalmembershipform_EnlistmentDate.siblings('input.dob-input-mask-field-datepicker').val();
      var DichargeDateVal = digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').val();
      if ($.trim(EnlistmentDateVal) !== '') {
        digitalmembershipform_EnlistmentDate.parent().removeClass('empty');
      } else {
        digitalmembershipform_EnlistmentDate.parent().addClass('empty');
      }
      if ($.trim(DichargeDateVal) !== '') {
        digitalmembershipform_DichargeDate.parent().removeClass('empty');
      } else {
        digitalmembershipform_DichargeDate.parent().addClass('empty');
      }
      var EnlistmentDate = convertToDate(EnlistmentDateVal);
      var DichargeDate = convertToDate(DichargeDateVal);
      if (EnlistmentDate !== 'Invalid Date' && DichargeDate !== 'Invalid Date' && DichargeDate <= EnlistmentDate
        && $(digitalmembershipform_DichargeDate).siblings('span.help-block').length > 0) {
        digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').focus();
        if (EnlistmentDate > DichargeDate) {
          $(digitalmembershipform_DichargeDate).siblings('span.help-block')
            .html('<span class="field-validation-error">Discharge Date cannot be earlier than the Enlistment Date</span>');
          e.preventDefault();
          return false;
        } else if (DichargeDate.toDateString() === EnlistmentDate.toDateString()) {
          $(digitalmembershipform_DichargeDate).siblings('span.help-block')
            .html('<span class="field-validation-error">Discharge Date cannot be same to Enlistment Date</span>');
          e.preventDefault();
          return false;
        }
      }
    }
  };

  function convertToDate(dateString) {
    //  Convert a "dd/MM/yyyy" string into a Date object
    let d = dateString.split("/");
    let dat = new Date(d[2] + '/' + d[1] + '/' + d[0]);
    return dat;
  }

  setTimeout(function () {
    digitalmembershipform_EnlistmentDate.length > 0 && digitalmembershipform_EnlistmentDate
      .siblings('input.dob-input-mask-field-datepicker').on("blur", function (e) {
        ValidateDischargeAndEnlistmentDate(e);
      });
    digitalmembershipform_DichargeDate.length > 0 && digitalmembershipform_DichargeDate
      .siblings('input.dob-input-mask-field-datepicker').on("blur", function (e) {
        ValidateDischargeAndEnlistmentDate(e);
      });
  }, 1000);

  $('.rslqld-digital-membership-form.rslqld-membership-form-fields .cssMembershipApplicationType')
    .closest('fieldset').find('input[data-sc-field-name="MembershipApplicationType"]').each(function () {
      $(this).on('change', function () {
        var MembershipApplicationType = this;
        if (MembershipApplicationType !== undefined) {
          if ($(MembershipApplicationType).is(':checked') === true && $(MembershipApplicationType).val() === 'non-serving-membership-type') {
            $('.rslqld-digital-membership-form.rslqld-membership-form-fields .dob-input-mask-field-datepicker').each(function () {
              $(this).attr('disabled', 'true');
            })
            $('.rslqld-digital-membership-form.rslqld-membership-form-fields input[type=radio]').each(function () {
              if (MembershipApplicationType !== this)
                this.checked = false;
            })
            $('.rslqld-digital-membership-form.rslqld-membership-form-fields input[type=text]').each(function () {
              $(this).val('');
            })
            $('.rslqld-digital-membership-form.rslqld-membership-form-fields input[type=checkbox]').each(function () {
              if (MembershipApplicationType !== this)
                this.checked = false;
            })
          } else if ($(MembershipApplicationType).is(':checked') === true && $(MembershipApplicationType).val() === 'service-member-type') {
            $('.rslqld-digital-membership-form.rslqld-membership-form-fields .dob-input-mask-field-datepicker').each(function () {
              if (digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').length > 0
                && this.id === digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker')[0].id) {
                return;
              } else {
                $(this).removeAttr('disabled');
              }
            })
          }
        }
      })
    });

  $('.rslqld-digital-membership-form.rslqld-membership-form-fields .cssServingNow')
    .closest('fieldset').find('input[data-sc-field-name="ServingNow"]').each(function () {
      $(this).on('change', function () {
        var ServingNow = this;
        if (ServingNow !== undefined)
          if (digitalmembershipform_DichargeDate.length > 0 &&
            digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').length > 0) {
            if ($(ServingNow).is(':checked') === true && $(ServingNow).val() === 'true') {
              digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').each(function () {
                $(this).attr('disabled', 'true').removeAttr('data-val-required')
                  .removeAttr('required').removeAttr('data-val').val('');
              });
              digitalmembershipform_DichargeDate.siblings('span.help-block').each(function () {
                $(this).html('')
              });
            } else if ($(ServingNow).is(':checked') === true && $(ServingNow).val() === 'false') {
              digitalmembershipform_DichargeDate.siblings('input.dob-input-mask-field-datepicker').each(function () {
                $(this).attr('data-val-required', 'This field is required.')
                  .attr('required', true).attr('data-val', true).removeAttr('disabled');
              });
            }
          }
      })
    });
}

$(document).ready(function () {
  formEvents();
})

handleRecaptcha.execute();

(function ($) {
  var data_click = "unobtrusiveAjaxClick",
    data_target = "unobtrusiveAjaxClickTarget",
    data_validation = "unobtrusiveValidation";

  function getFunction(code, argNames) {
    var fn = window, parts = (code || "").split(".");
    while (fn && parts.length) {
      fn = fn[parts.shift()];
    }
    if (typeof (fn) === "function") {
      return fn;
    }
    argNames.push(code);
    return Function.constructor.apply(null, argNames);
  }

  function isMethodProxySafe(method) {
    return method === "GET" || method === "POST";
  }

  function asyncOnBeforeSend(xhr, method) {
    if (!isMethodProxySafe(method)) {
      xhr.setRequestHeader("X-HTTP-Method-Override", method);
    }
  }

  function asyncOnSuccess(element, data, contentType) {
    var mode;

    if (contentType.indexOf("application/x-javascript") !== -1) {// jQuery already executes JavaScript for us
      return;
    }

    mode = (element.getAttribute("data-ajax-mode") || "").toUpperCase();
    $(element.getAttribute("data-ajax-update")).each(function (i, update) {
      var top;

      switch (mode) {
        case "BEFORE":
          $(update).prepend(data);
          break;
        case "AFTER":
          $(update).append(data);
          break;
        case "REPLACE-WITH":
          $(update).replaceWith(data);
          break;
        default:
          $(update).html(data);
          break;
      }
    });
  }

  function asyncRequest(element, options) {
    var confirm, loading, method, duration;

    confirm = element.getAttribute("data-ajax-confirm");
    if (confirm && !window.confirm(confirm)) {
      return;
    }

    loading = $(element.getAttribute("data-ajax-loading"));
    duration = parseInt(element.getAttribute("data-ajax-loading-duration"), 10) || 0;

    $.extend(options, {
      type: element.getAttribute("data-ajax-method") || undefined,
      url: element.getAttribute("data-ajax-url") || undefined,
      cache: (element.getAttribute("data-ajax-cache") || "").toLowerCase() === "true",
      beforeSend: function (xhr) {
        var result;
        asyncOnBeforeSend(xhr, method);
        result = getFunction(element.getAttribute("data-ajax-begin"), ["xhr"]).apply(element, arguments);
        if (result !== false) {
          loading.show(duration);
        }
        return result;
      },
      complete: function (data) {
        loading.hide(duration);
        getFunction(element.getAttribute("data-ajax-complete"), ["xhr", "status"]).apply(element, arguments);
        handleRecaptcha.checkCaptchaOnAjaxCall(data);
        formEvents();
        renderFields.Date();
      },
      success: function (data, status, xhr) {
        asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
        getFunction(element.getAttribute("data-ajax-success"), ["data", "status", "xhr"]).apply(element, arguments);
      },
      error: function () {
        getFunction(element.getAttribute("data-ajax-failure"), ["xhr", "status", "error"]).apply(element, arguments);
      }
    });

    method = options.type.toUpperCase();
    if (options.data instanceof FormData) {
      options.processData = false;
      options.contentType = false;
      options.data.append("X-Requested-With", "XMLHttpRequest");

      if (!isMethodProxySafe(method)) {
        options.type = "POST";
        options.data.append("X-HTTP-Method-Override", method);
      }
    } else {
      options.data.push({ name: "X-Requested-With", value: "XMLHttpRequest" });

      if (!isMethodProxySafe(method)) {
        options.type = "POST";
        options.data.push({ name: "X-HTTP-Method-Override", value: method });
      }
    }

    $.ajax(options);
  }

  function validate(form) {
    var validationInfo = $(form).data(data_validation);
    return !validationInfo || !validationInfo.validate || validationInfo.validate();
  }

  $(document).off("submit", "form[data-ajax=true]").on("submit", "form[data-ajax=true]", function (evt) {
    var clickInfo = $(this).data(data_click) || [],
      clickTarget = $(this).data(data_target),
      isCancel = clickTarget && (clickTarget.hasClass("cancel") || clickTarget.attr('formnovalidate') !== undefined);
    evt.preventDefault();
    if (!isCancel && !validate(this)) {
      return;
    }
    var formData;
    if (this.enctype && this.enctype === "multipart/form-data") {
      var formClone = $(this);
      var buttonInfo = [];
      for (var i = 0; i < clickInfo.length; i++) {
        var origClickInfo = $(formClone).find("#" + clickInfo[i].name.replace(/\./g, "_"));
        buttonInfo.push({ name: clickInfo[i].name, value: clickInfo[i].value });
        if (origClickInfo.length > 0) {
          buttonInfo.push({ name: clickInfo[i].name, value: $(origClickInfo)[0].value });
          $(origClickInfo).remove();
        }
      }
      formData = new FormData(formClone[0]);
      for (var i = 0; i < buttonInfo.length; i++) {
        if (formData.has(buttonInfo[i].name) && formData.get(buttonInfo[i].name) === buttonInfo[i].value) {
          formData.delete(buttonInfo[i].name);
        }
        formData.append(buttonInfo[i].name, buttonInfo[i].value);
      }
    } else {
      formData = clickInfo.concat($(this).serializeArray());
    }

    asyncRequest(this, {
      url: this.action,
      type: this.method || "GET",
      data: formData
    });
  });
}(jQuery));
